export default "__VITE_ASSET__BDR8AwR1__"